import { render } from "./AddProduitRestreint.vue?vue&type=template&id=d185908c&ts=true"
import script from "./AddProduitRestreint.vue?vue&type=script&lang=ts"
export * from "./AddProduitRestreint.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__